import { NgClass } from '@angular/common';
import { Component, ViewEncapsulation, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { FuseConfirmationConfig } from '@fuse/services/confirmation/confirmation.types';

@Component({
    selector: 'fuse-confirmation-dialog',
    templateUrl: './dialog.component.html',
    styles: [
        `
            .fuse-confirmation-dialog-panel {
                @screen md {
                    @apply w-128;
                }

                .mat-mdc-dialog-container {
                    .mat-mdc-dialog-surface {
                        padding: 0 !important;
                    }
                }
            }

            /* Soft green confirm button (success) */
            .confirm-btn-success {
                background-color: #10b981 !important;
                color: white !important;

                &:hover {
                    background-color: #059669 !important;
                }
            }

            /* Soft red confirm button for destructive actions (warn/danger) */
            .confirm-btn-danger {
                background-color: #ef4444 !important;
                color: white !important;

                &:hover {
                    background-color: #dc2626 !important;
                }
            }

            /* Primary button styling */
            .confirm-btn-primary {
                background-color: #0097A9 !important;
                color: white !important;

                &:hover {
                    background-color: #007d8a !important;
                }
            }

            /* Soft red cancel button - danger style */
            .cancel-btn-danger {
                border-color: #f87171 !important;
                color: #dc2626 !important;

                &:hover {
                    background-color: rgba(248, 113, 113, 0.1) !important;
                }
            }

            /* Warn style for cancel */
            .cancel-btn-warn {
                border-color: #fbbf24 !important;
                color: #d97706 !important;

                &:hover {
                    background-color: rgba(251, 191, 36, 0.1) !important;
                }
            }

            /* Basic/neutral cancel button */
            .cancel-btn-basic {
                border-color: #9ca3af !important;
                color: #6b7280 !important;

                &:hover {
                    background-color: rgba(156, 163, 175, 0.1) !important;
                }
            }
        `,
    ],
    encapsulation: ViewEncapsulation.None,
    imports: [MatButtonModule, MatDialogModule, MatIconModule, NgClass],
})
export class FuseConfirmationDialogComponent {
    data: FuseConfirmationConfig = inject(MAT_DIALOG_DATA);
}
